import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Service } from '../types';
import {
  ClipboardList,
  CreditCard,
  Database,
  FileText,
  Settings,
  Folder,
  BarChart2,
  Package,
  Smartphone,
  Cpu,
  Link,
  LayoutTemplate,
  Star,
  LucideIcon
} from 'lucide-react';
import './ServiceTile.css';

const ICON_MAP: Record<string, LucideIcon> = {
  'clipboard-list': ClipboardList,
  'credit-card': CreditCard,
  'database': Database,
  'file-text': FileText,
  'settings': Settings,
  'folder': Folder,
  'bar-chart-2': BarChart2,
  'package': Package,
  'smartphone': Smartphone,
  'cpu': Cpu,
  'link': Link,
  'layout-template': LayoutTemplate,
};

interface ServiceTileProps {
  service: Service;
  isFavorite?: boolean;
  onFavoriteToggle?: (id: string) => void;
}

const ServiceTile: React.FC<ServiceTileProps> = ({ service, isFavorite, onFavoriteToggle }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (service.hasAccess) {
      if (service.url.startsWith('http')) {
        window.open(service.url, '_blank');
      } else if (service.url.startsWith('/workplane') || service.url.startsWith('/pay') || service.url.startsWith('/stats') || service.url.startsWith('/adminer') || service.url.startsWith('/admin')) {
        window.location.href = service.url;
      } else {
        navigate(service.url);
      }
    }
  };

  const handleFavoriteClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (service.hasAccess && onFavoriteToggle) {
      onFavoriteToggle(service.id);
    }
  };

  const IconComponent = ICON_MAP[service.icon];
  const showEmoji = !IconComponent && service.icon;

  return (
    <div
      className={`service-tile ${service.hasAccess ? 'service-tile--active' : 'service-tile--disabled'}`}
      onClick={handleClick}
      title={service.hasAccess ? `Открыть ${service.name}` : 'Нет доступа'}
    >
      <div
        className="service-tile-icon"
        style={{
          background: service.hasAccess ? service.color : '#d1d5db',
        }}
      >
        {IconComponent ? (
          <IconComponent size={24} color="white" />
        ) : showEmoji ? (
          <span className="service-tile-emoji">{service.icon}</span>
        ) : (
          <Folder size={24} color="white" />
        )}
      </div>
      <div className="service-tile-content">
        <h3 className="service-tile-name">{service.name}</h3>
        <p className="service-tile-description">{service.description}</p>
      </div>
      <div
        className={`service-tile-favorite ${!service.hasAccess ? 'service-tile-favorite--disabled' : ''} ${isFavorite ? 'service-tile-favorite--active' : ''}`}
        onClick={service.hasAccess ? handleFavoriteClick : undefined}
        title={!service.hasAccess ? 'Нет доступа' : isFavorite ? 'Убрать из избранного' : 'Добавить в избранное'}
      >
        {!service.hasAccess ? (
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
        ) : (
          <Star size={18} fill={isFavorite ? '#f59e0b' : 'none'} color={isFavorite ? '#f59e0b' : '#9ca3af'} />
        )}
      </div>
    </div>
  );
};

export default ServiceTile;
